module.exports = __webpack_public_path__ + "static/img/cont62 (1).1f1c36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont62 (1).jpg
// module id = 3ugE
// module chunks = 0